<script lang="ts">
  interface Props {
    css?: string;
  }

  let { css = "w-5 h-5 fill-gray-300" }: Props = $props();
</script>

<svg  class={css} width="20" height="20"viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.5 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-4.644-1.142l-4.29 1.117a.85.85 0 0 1-1.037-1.036l1.116-4.289A9.96 9.96 0 0 1 2.5 12c0-5.523 4.477-10 10-10m1.252 11H9.25l-.102.007a.75.75 0 0 0 0 1.486l.102.007h4.502l.101-.007a.75.75 0 0 0 0-1.486zm1.998-3.5h-6.5l-.102.007a.75.75 0 0 0 0 1.486L9.25 11h6.5l.102-.007a.75.75 0 0 0 0-1.486z" fill="gray-300"></path>
</svg>